import { useRegister } from "./RegisterContext";
import AthleteForm from "./roles/AthleteForm";
import StaffForm from "./roles/StaffForm";
import LawyerForm from "./roles/LawyerForm";
import ClubForm from "./roles/ClubForm";
import MediaForm from "./roles/MediaForm";
import BrandForm from "./roles/BrandForm";
import FanForm from "./roles/FanForm";
import RegisterSuccessModal from "./RegisterSuccessModal";
import { useTranslation } from "react-i18next";

export default function RegisterStep2() {
  const { t } = useTranslation();
  const {
    step,
    profile,
    prev,
    next,
    showSuccessModal,
    setShowSuccessModal,
  } = useRegister();
  if (step !== 2) return null;


  const renderForm = () => {
    switch (profile) {
      case "athlete": return <AthleteForm />;
      case "staff": return <StaffForm />;
      case "lawyer": return <LawyerForm />;
      case "club": return <ClubForm />;
      case "media": return <MediaForm />;
      case "brand": return <BrandForm />;
      case "fan": return <FanForm />;
      default: return null;
    }
  };


  return (
    <div className="register-step register-step--form register-animate">
      <h2>
        {t("registerStep2.title")} — {t(`profile.${profile}`)}
      </h2>
      {renderForm()}

      <div className="register-actions">
        <button type='button' className="register-secondary-btn" onClick={prev}>
          {t("registerStep2.back")}
        </button>

        <button
          type="button"
          className="register-primary-btn"
          onClick={() => {
            const form = document.querySelector(".register-form-grid");

            if (form && !form.checkValidity()) {
              form.reportValidity();
              return;
            }

            next();
          }}
        >
          {t("registerStep2.continue")}
        </button>
      </div>
      {showSuccessModal && (
        <RegisterSuccessModal
          onClose={() => setShowSuccessModal(false)}
        />
      )}
    </div>
  );
}
